import { Tile, TileLayoutItem, TileSize } from '../types/tile.types';

/** Sortiert Kacheln nach dem gespeicherten Layout. Kacheln, die im Layout noch fehlen (neu
 * freigegeben oder neu angelegt), behalten ihre bisherige Reihenfolge und landen am Ende. */
export function orderTilesByLayout(tiles: Tile[], layout: TileLayoutItem[]): Tile[] {
  if (!layout.length) return tiles;
  const position = new Map(layout.map((item, index) => [item.tileId, index]));
  const known = tiles.filter(tile => position.has(tile._id)).sort((a, b) => position.get(a._id)! - position.get(b._id)!);
  const unknown = tiles.filter(tile => !position.has(tile._id));
  return [...known, ...unknown];
}

/** Baut das zu speichernde Layout aus der aktuellen Reihenfolge, den Größen und den entfernten Kacheln. */
export function toTileLayout(tiles: Tile[], sizes: Record<string, TileSize>, hidden: ReadonlySet<string> = new Set()): TileLayoutItem[] {
  return tiles.map(tile => ({ tileId: tile._id, size: sizes[tile._id] ?? '1x1', ...(hidden.has(tile._id) ? { hidden: true } : {}) }));
}

/** Liegt der Zeiger im inneren Bereich der Kachel? `inset` ist der Rand je Seite als Anteil von
 * Breite bzw. Höhe, der nicht zählt (0.25 = nur die mittlere Hälfte). */
export function isInSnapZone(rect: Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom'>, x: number, y: number, inset = 0.25): boolean {
  const insetX = (rect.right - rect.left) * inset;
  const insetY = (rect.bottom - rect.top) * inset;
  return x >= rect.left + insetX && x <= rect.right - insetX && y >= rect.top + insetY && y <= rect.bottom - insetY;
}
